import React from 'react'
import { Card, Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { thousandSeparator } from '../helper/utils';
import { InformationCircleIcon } from '@heroicons/react/24/outline';
import { CartItem } from '../context/cart-context';
import { LocalCurrency } from '../types';

interface CheckoutOrderDetailsProps {
    cartItems: CartItem[];
    cartTotal: number;
    shippingCharge: number;
    extraShippingCharge: number;
    shouldAddShipping: boolean;
    totalQuantity: number;
}

export const CheckoutOrderDetails = (props: CheckoutOrderDetailsProps) => {
    const { cartItems, cartTotal, shouldAddShipping, shippingCharge, extraShippingCharge, totalQuantity } = props;

    return (
        <Card>
            <Card.Header style={{color:'#000', backgroundColor: '#fff', paddingLeft: '.5rem'}}>Order Details</Card.Header>
            <Card.Body style={{ fontSize: '.9rem', color: '#000' }} className='p-0'>
                {cartItems.map((cartItem: CartItem, i: number) => (
                    <div className='border-bottom px-2 py-2 pb-2' key={`order-details-${i}`}>
                        <Row className='d-flex flex-row justify-content-start align-items-center'>
                            {
                                cartItem.image ? (
                                    <Col sm={7} xs={7}>
                                        <img alt={cartItem.name} src={cartItem.image} width={40} height={40} className='me-2' />
                                    </Col>
                                ): (
                                    <Col sm={7} xs={7}>
                                        <strong>{cartItem.name}</strong>
                                    </Col>
                                )
                            }
                            <Col sm={2} xs={1}>{cartItem.quantity}</Col>
                            <Col sm={3} xs={4} className='text-center'>
                                <p className='m-0'>{cartItem.priceString}</p> 
                                <p className='m-0 text-primary' style={{textDecoration: 'line-through', fontSize: '.7rem'}}>{cartItem.strikeThroughPriceString}</p>
                            </Col>
                        </Row>
                    </div>
                ))}

                {
                    cartItems.length > 0 && (
                        <>
                            <div className='border-bottom px-2 pt-3 pb-2'>
                                <Row>
                                    <Col sm={9} xs={7}>
                                        Item SubTotal
                                    </Col>
                                    <Col sm={3} xs={5} className='text-center'>
                                        <p className='m-0' style={{fontWeight: 900}}>{LocalCurrency.naira}{thousandSeparator(cartTotal.toFixed(2))}</p> 
                                    </Col>
                                </Row>
                                {
                                    shouldAddShipping && (
                                        <>
                                            <Row>
                                                <Col sm={9} xs={7}>
                                                    Base Shipping Fee &nbsp;
                                                    <OverlayTrigger
                                                        placement='top'
                                                        delay={{ show: 250, hide: 400 }}
                                                        overlay={(props) => (
                                                            <Tooltip id="button-tooltip" {...props}>
                                                                <p style={{textAlign: 'left'}}>
                                                                    <small>Our logistic company will ship this order to your delivery location. 
                                                                        However, you can disable shipping if you intent to pickup at the store.</small>
                                                                </p>
                                                            </Tooltip>
                                                        )}
                                                    >
                                                        <InformationCircleIcon width={16} height={16} style={{cursor: 'pointer'}} />
                                                    </OverlayTrigger>
                                                </Col>
                                                <Col sm={3} xs={5} className='text-center'>
                                                    <p className='m-0 text-right' style={{fontWeight: 900}}>{LocalCurrency.naira}{thousandSeparator(shippingCharge.toFixed(2))}</p> 
                                                </Col>
                                            </Row>
                                            {
                                                extraShippingCharge > 0 && (
                                                    <Row>
                                                        <Col sm={9} xs={7}>
                                                            Extra Shipping Fee &nbsp;
                                                            <OverlayTrigger
                                                                placement='top'
                                                                delay={{ show: 250, hide: 400 }}
                                                                overlay={(props) => (
                                                                    <Tooltip id="button-tooltip" {...props}>
                                                                        <p style={{textAlign: 'left'}}>
                                                                            <small>Extra shipping fee is half of the base shipping fee which covers for the extra {(totalQuantity - 1) > 0 ? (totalQuantity - 1) : ''} carton</small>
                                                                        </p>
                                                                    </Tooltip>
                                                                )}
                                                            >
                                                                <InformationCircleIcon width={16} height={16} style={{cursor: 'pointer'}} />
                                                            </OverlayTrigger>
                                                        </Col>
                                                        <Col sm={3} xs={5} className='text-center'>
                                                            <p className='m-0' style={{fontWeight: 900}}>{LocalCurrency.naira}{thousandSeparator(extraShippingCharge.toFixed(2))}</p> 
                                                        </Col>
                                                    </Row>
                                                )
                                            }
                                        </>
                                    )
                                }
                            </div>
                            <div className='border-bottom px-2 pt-3 pb-2'>
                                <Row>
                                    <Col sm={9} xs={7}>
                                        Grand Total
                                    </Col>
                                    <Col sm={3} xs={5} className='text-center'>
                                        <p className='m-0' style={{fontWeight: 900}}>
                                            {LocalCurrency.naira}
                                            {thousandSeparator((
                                                cartTotal + 
                                                ((shouldAddShipping) ? shippingCharge : 0) + 
                                                ((shouldAddShipping && (totalQuantity - 1) > 0) ? extraShippingCharge : 0)
                                            ).toFixed(2))}</p> 
                                    </Col>
                                </Row>
                            </div>
                        </>
                    )
                }
            </Card.Body>
        </Card>
    )
}
